import { use } from "react";

import { useMultiplayerContext } from "../../hooks/use-multiplayer-context";
import { TranscriptionContext } from "../../providers/transcription-context";
import { prettyDateTime } from "../../utils/pretty-date-time";

export function LastSavedStatus() {
  const { dispatch, lastSaved } = use(TranscriptionContext);
  useMultiplayerContext((message) => {
    // update last saved status when our own changes are saved
    if (message.type === "ack-revision") {
      dispatch({ type: "saved", date: new Date() });
    }
  });
  if (!lastSaved) return null;
  return (
    <span
      className="overflow-hidden text-xs text-ellipsis whitespace-nowrap text-green-800"
      title={lastSaved ? `Last saved at ${prettyDateTime(`${lastSaved}`)}` : ""}
    >
      Last saved at {prettyDateTime(`${lastSaved}`)}
    </span>
  );
}
